import { render } from "./SummarySellerSection.vue?vue&type=template&id=60e74e6d"
import script from "./SummarySellerSection.vue?vue&type=script&lang=js"
export * from "./SummarySellerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__